import React from 'react';

// کامپوننت آیکون‌های SVG برای کارکرد ۱۰۰٪ آفلاین در داشبورد یوگا
const DashboardOfflineIcon = ({ name, color = '#94a3b8', size = 24 }) => {
  const icons = {
    self_improvement: <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm7 7h-6v3h4v8h-2v-6h-2v6H9v-8h4V9H7V7h12v2z"/>,
    logout: <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>,
    local_fire_department: <path d="M12 23c-4.42 0-8-3.58-8-8 0-4.24 3.22-7.56 7.42-7.94L11 8.5c-.02.17-.05.34-.05.5 0 2.21 1.79 4 4 4 .53 0 1.03-.1 1.48-.3-.21.91-.71 1.71-1.43 2.3 1.25.13 2.5-.24 3.33-1.21.43 1 .67 2.11.67 3.21 0 4.42-3.58 8-8 8zm-.54-18.01c-.13.51-.21 1.04-.21 1.59 0 3.12 2.35 5.71 5.37 6.07C16.14 7.63 12.44 4.56 11.46 4.99z"/>,
    schedule: <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>,
    trophy: <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v3c0 2.55 1.92 4.67 4.41 4.94C8.42 15.72 10.05 17 12 17s3.58-1.28 4.59-3.06C19.08 13.67 21 11.55 21 9V7c0-1.1-.9-2-2-2zM5 10V7h2v3H5zm14 0h-2V7h2v3zm-7 9c-1.66 0-3-1.34-3-3h6c0 1.66-1.34 3-3 3z"/>,
    timer: <path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>,
    person: <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>,
    home: <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>,
    explore: <path d="M12 2C6.48 2 2 6.48 2 12s4.47 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14.22l-4.22-1 1-4.22 4.22 1-1 4.22z"/>,
    accessibility_new: <path d="M14 4c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2 3c-1.66 0-3 1.34-3 3v7h2v5h2v-5h2v-7c0-1.66-1.34-3-3-3z"/>,
    rowing: <path d="M8.5 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm13 9.5l-2.7-2.7-1.4 1.4 3.2 3.2 1.4-1.4zm-19-1l1.4-1.4 4.3 4.3L6.8 17.8l-4.3-4.3zm12.2-3.1l-1.9-1.9c-.4-.4-1-.4-1.4 0l-4.2 4.2 1.4 1.4 3.5-3.5V23h2v-8.5l1.9 1.9 1.4-1.4-2.7-2.7z"/>
  };

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={{ display: 'block' }}>
      {icons[name] || null}
    </svg>
  );
};

function YogaDashboard({ onBackToMain, children }) {
  return (
    <div style={{
      backgroundColor: '#0c0d12',
      color: '#ffffff',
      minHeight: '100vh',
      paddingBottom: '100px',
      fontFamily: 'Vazirmatn, Tahoma, sans-serif',
      boxSizing: 'border-box'
    }} dir="rtl">

      {/* هدر اصلی پلتفرم */}
      <header style={{
        backgroundColor: '#131520',
        height: '64px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 24px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        position: 'sticky',
        top: 0,
        zIndex: 50
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <DashboardOfflineIcon name="self_improvement" color="#a855f7" size={28} />
          <h1 style={{ fontSize: '20px', fontWeight: '700', margin: 0, letterSpacing: '-0.5px' }}>یوگافیت</h1>
        </div>
        
        <button 
          onClick={onBackToMain}
          style={{
            background: 'transparent',
            color: '#94a3b8',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'inherit'
          }}
        >
          <DashboardOfflineIcon name="logout" color="#94a3b8" size={18} />
          اتمام جلسه و خروج
        </button>
      </header>

      {/* محتوای متراکم و غنی داشبورد */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: '32px' }}>
        
        {/* کادر دموی هوش مصنوعی */}
        <section style={{
          width: '100%',
          borderRadius: '24px',
          overflow: 'hidden',
          border: '1px solid rgba(168, 85, 247, 0.2)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          backgroundColor: '#000000'
        }}>
          {children}
        </section>

        {/* بخش خوش‌آمدگویی متنی */}
        <section>
          <h2 style={{ fontSize: '28px', fontWeight: '700', margin: 0 }}>خوش‌آمدی، ساناز عزیز</h2>
          <p style={{ fontSize: '15px', color: '#94a3b8', marginTop: '4px' }}>برای تمرین امروز آماده‌ای؟ مربی هوش مصنوعی شما کالیبره و فعال است.</p>
        </section>

        {/* بنتو باکس عددی و آماری کاملاً آفلاین */}
        <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
          <div style={{ backgroundColor: '#131520', padding: '24px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ backgroundColor: 'rgba(168, 85, 247, 0.1)', padding: '12px', borderRadius: '14px', display: 'flex' }}>
              <DashboardOfflineIcon name="local_fire_department" color="#c084fc" size={28} />
            </div>
            <div>
              <span style={{ fontSize: '13px', color: '#94a3b8', display: 'block', marginBottom: '2px' }}>کالری مصرف شده</span>
              <span style={{ fontSize: '24px', fontWeight: '700' }}>۴۲۰ <span style={{ fontSize: '14px', color: '#94a3b8', fontWeight: '400' }}>کیلوکالری</span></span>
            </div>
          </div>

          <div style={{ backgroundColor: '#131520', padding: '24px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ backgroundColor: 'rgba(168, 85, 247, 0.1)', padding: '12px', borderRadius: '14px', display: 'flex' }}>
              <DashboardOfflineIcon name="schedule" color="#c084fc" size={28} />
            </div>
            <div>
              <span style={{ fontSize: '13px', color: '#94a3b8', display: 'block', marginBottom: '2px' }}>مدت زمان تمرین</span>
              <span style={{ fontSize: '24px', fontWeight: '700' }}>۳۵ <span style={{ fontSize: '14px', color: '#94a3b8', fontWeight: '400' }}>دقیقه</span></span>
            </div>
          </div>

          <div style={{ backgroundColor: '#131520', padding: '24px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ backgroundColor: 'rgba(168, 85, 247, 0.1)', padding: '12px', borderRadius: '14px', display: 'flex' }}>
              <DashboardOfflineIcon name="trophy" color="#c084fc" size={28} />
            </div>
            <div>
              <span style={{ fontSize: '13px', color: '#94a3b8', display: 'block', marginBottom: '2px' }}>تداوم روزانه (Streak)</span>
              <span style={{ fontSize: '24px', fontWeight: '700' }}>۱۲ <span style={{ fontSize: '14px', color: '#94a3b8', fontWeight: '400' }}>روز</span></span>
            </div>
          </div>
        </section>

        {/* فیلترها و تب‌های ناوبری */}
        <section style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '4px' }}>
          <button style={{ backgroundColor: '#ffffff', color: '#0c0d12', padding: '10px 24px', borderRadius: '30px', border: 'none', fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}>همه تمرین‌ها</button>
          <button style={{ backgroundColor: '#131520', color: '#94a3b8', padding: '10px 24px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.05)', fontSize: '14px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit' }}>انعطاف‌پذیری</button>
          <button style={{ backgroundColor: '#131520', color: '#94a3b8', padding: '10px 24px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.05)', fontSize: '14px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit' }}>قدرت بدنی</button>
          <button style={{ backgroundColor: '#131520', color: '#94a3b8', padding: '10px 24px', borderRadius: '30px', border: '1px solid rgba(255,255,255,0.05)', fontSize: '14px', fontWeight: '500', cursor: 'pointer', fontFamily: 'inherit' }}>ذهن‌آگاهی</button>
        </section>

        {/* لیست دقیق برنامه‌های پیشنهادی */}
        <section style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', margin: 0 }}>برنامه‌های پیشنهادی</h3>
            <span style={{ fontSize: '14px', color: '#a855f7', fontWeight: '600', cursor: 'pointer' }}>مشاهده همه</span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px' }}>
            
            {/* کارت تمرینی ۱ */}
            <div style={{ backgroundColor: '#131520', borderRadius: '24px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '160px', backgroundColor: '#1e2235', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <DashboardOfflineIcon name="accessibility_new" color="#a855f7" size={56} />
                <span style={{ position: 'absolute', top: '16px', right: '16px', backgroundColor: '#a855f7', color: '#fff', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>محبوب</span>
              </div>
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <h4 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>اصول تراز و توازن ستون فقرات</h4>
                <p style={{ fontSize: '14px', color: '#94a3b8', margin: 0, lineHeight: '22px' }}>بهبود وضعیت بدن و اصلاح تقارن اسکلتی با استفاده از پایش و ردیابی دقیق زوایای بدن توسط هوش مصنوعی.</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', paddingTop: '16px', borderTop: '1px solid rgba(255,255,255,0.03)' }}>
                  <span style={{ fontSize: '13px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <DashboardOfflineIcon name="timer" color="#94a3b8" size={18} /> ۲۰ دقیقه
                  </span>
                  <span style={{ fontSize: '13px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <DashboardOfflineIcon name="person" color="#94a3b8" size={18} /> مربی: سارا
                  </span>
                </div>
              </div>
            </div>

            {/* کارت تمرینی ۲ */}
            <div style={{ backgroundColor: '#131520', borderRadius: '24px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.03)', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '160px', backgroundColor: '#1e2235', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <DashboardOfflineIcon name="rowing" color="#a855f7" size={56} />
              </div>
              <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <h4 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>جریان پایداری و قدرت هسته بدن</h4>
                <p style={{ fontSize: '14px', color: '#94a3b8', margin: 0, lineHeight: '22px' }}>تمرکز عمیق بر حرکات تعادلی و استقامتی. بسیار مناسب برای آزمایش و سنجش زوایای مفصل ران و مچ پا.</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', paddingTop: '16px', borderTop: '1px solid rgba(255,255,255,0.03)' }}>
                  <span style={{ fontSize: '13px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <DashboardOfflineIcon name="timer" color="#94a3b8" size={18} /> ۱۵ دقیقه
                  </span>
                  <span style={{ fontSize: '13px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <DashboardOfflineIcon name="person" color="#94a3b8" size={18} /> مربی: داوود
                  </span>
                </div>
              </div>
            </div>

          </div>
        </section>

      </main>

      {/* ناوبری پایینی ثابت کاملاً آفلاین */}
      <nav style={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        width: '100%', 
        backgroundColor: '#131520', 
        borderTop: '1px solid rgba(255,255,255,0.05)', 
        display: 'flex', 
        justifyContent: 'space-around', 
        padding: '12px 0 20px 0', 
        zIndex: 100 
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#a855f7', gap: '4px', cursor: 'pointer' }}>
          <DashboardOfflineIcon name="home" color="#a855f7" size={24} />
          <span style={{ fontSize: '12px', fontWeight: '600' }}>داشبورد</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94a3b8', gap: '4px', cursor: 'pointer' }}>
          <DashboardOfflineIcon name="explore" color="#94a3b8" size={24} />
          <span style={{ fontSize: '12px' }}>اکتشاف</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#94a3b8', gap: '4px', cursor: 'pointer' }}>
          <DashboardOfflineIcon name="person" color="#94a3b8" size={24} />
          <span style={{ fontSize: '12px' }}>پروفایل</span>
        </div>
      </nav>

    </div>
  );
}

export default YogaDashboard;